import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-component',
  templateUrl: './workflow-component.component.html',
  styleUrls: ['./workflow-component.component.scss']
})
export class WorkflowComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    if (!sessionStorage.getItem('reloaded')) {
      sessionStorage.setItem('reloaded', 'true');
      window.location.reload();
    
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/workflow-component/workflow-component.component.ts